<template>
  <v-layout
    align-center
    justify-center
    row
    wrap
    fill-height
    class="pa-0 ma-0 page"
  >
    <v-container>
      <v-layout align-center justify-center column wrap class="pa-3 ma-3">
        <div class="text-center pa-3">
          <v-img src="../../../img/newJuntos_logo_color.png" width="220px" />
        </div>
        <div class="text-center pa-3 font-weight-bold">
          Sua negociação foi realizada com sucesso!
        </div>
        <div class="text-center pt-3">
          <v-btn dark color="indigo" @click="goToInvoices"
            >Ver minhas faturas e parcelas</v-btn
          >
        </div>
      </v-layout>
    </v-container>
    <Footer />
  </v-layout>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import Footer from "../../components/members/Footer.vue";
export default {
  components: { Footer },
  computed: {
    ...mapGetters("members", ["chargeParcel", "currentUser"]),
    ...mapState("members", ["currentUser"]),
  },
  methods: {
    goToInvoices() {
      let path =
        "/membros/faturas/" + (this.currentUser ? this.currentUser.id : "");
      console.log("path: ", path);
      this.$router.push(path);
    },
  },
};
</script>
<style scoped>
.page {
  height: 100vh;
  background: #fff;
}
</style>
